export default __webpack_public_path__ + "844d5686bf65331711d696e23a40287b.png";